import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Parameter } from '../../../shared/interfaces/account.interfaces';

const basePath = '/account/parameter';

@Injectable({
  providedIn: 'root',
})

export class AccountParameterService {
  constructor(private http: HttpClient) { }

  // Get all parameters (users/zones) of a given account
  getAccountParameters(accountId: number | undefined): Observable<Parameter[]> {
    return this.http.get<Parameter[]>(`${basePath}/${accountId}`);
  }

  // Create a new parameter (user/zone)
  createParameter(payload: Parameter): Observable<Parameter> {
    const body = payload;
    return this.http.post<Parameter>(`${basePath}`, body);
  }

  // Updates a parameter (user/zone) name, number and type
  updateParameter(payload: Parameter): Observable<any> {
    const body = payload;
    return this.http.put<any>(`${basePath}`, body);
  }

  // Deletes a parameter (user/zone) by its ID
  deleteParameter(parameterId: number): Observable<any> {
    return this.http.delete<any>(`${basePath}/${parameterId}`);
  }

  // Get available parameter types
  getAccountParameterTypes(): Observable<any> {
    return this.http.get<any>(`${basePath}/types`);
  }

}